import React from 'react';
import createReactClass from 'create-react-class';
import reportsConfig from './config/reportsConfig';
import setViewTitle from '../../helpers/setViewTitle';
import auth0 from '../../helpers/auth0';

var Timepark = createReactClass({

  getInitialState() {
    return {
      accessToken: auth0.getAccessToken(),
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear()
    };
  },

  componentWillMount() {
    setViewTitle('Timepark');
  },

  handleChange(e) {
    var propName = e.target.name;
    var value = e.target.value;

    var newState = {};
    newState[propName] = value;

    this.setState(newState);
  },

  render() {

    let invisible = {
      display: 'none'
    };

    let { accessToken } = this.state;
    let downloadUrl = reportsConfig.timeparkUrl + '?month=' + this.state.month + '&year=' + this.state.year + '&api_key=' + accessToken;

    return (
            <div className="jarviswidget jarviswidget-color-blueDark" data-widget-editbutton="false">
                <iframe id="download_frame" title="Download" style={invisible} />
                <header>
                    <span className="widget-icon"> <i className="fa fa fa-lg fa-clock-o"></i> </span>
                    <h2>Timepark</h2>
                </header>
                <div>
                    <div className="jarviswidget-editbox"></div>
                    <div className="widget-body no-padding">

                        <form method="post" className="smart-form">

                            <fieldset>
                                <div className="row">
                                    <section className="col col-3">
                                        Monat
                                        <label className="input">
                                            <i className="icon-append fa fa-dot-circle-o"></i>
                                            <select name="month" className="form-control" value={this.state.month} onChange={this.handleChange}>
                                              <option value="1">Jänner</option>
                                              <option value="2">Feber</option>
                                              <option value="3">März</option>
                                              <option value="4">April</option>
                                              <option value="5">Mai</option>
                                              <option value="6">Juni</option>
                                              <option value="7">Juli</option>
                                              <option value="8">August</option>
                                              <option value="9">September</option>
                                              <option value="10">Oktober</option>
                                              <option value="11">November</option>
                                              <option value="12">Dezember</option>
                                            </select>
                                        </label>

                                    </section>
                                    <section className="col col-3">
                                        Jahr
                                        <label className="input">
                                            <i className="icon-append fa fa-dot-circle-o"></i>
                                            <input type="number" name="year" min="2015" max={new Date().getFullYear()} value={this.state.year} onChange={this.handleChange} />
                                        </label>
                                    </section>
                                </div>

                            </fieldset>

                            <footer>
                                <a type="button" className="btn btn-primary" href={downloadUrl}>
                                    Download
                                </a>
                            </footer>

                        </form>
                    </div>
                </div>
            </div>
        );

  }

});

export default Timepark;



// WEBPACK FOOTER //
// ./src/components/reports/Timepark.js